<div class="icon">
  <ng-content select="[statusIcon]"></ng-content>
</div>
<div class="label">
  <ng-content select="[statusLabel]"></ng-content>
</div>
